import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabaseClient";
import type { SharedOfficialLinkNotice } from "./officialNoticeItems";

/**
 * The RPC is not in the database yet (rollout window before migration
 * 20261012094602): PostgREST answers PGRST202, Postgres 42883.
 */
const isMissingFunction = (error: { code?: string } | null | undefined): boolean =>
  error?.code === "PGRST202" || error?.code === "42883";

/** Memberships added in the last 14 days to people who are also in a league I preside (super-admin: all). */
export function useSharedOfficialNotices(enabled: boolean) {
  return useQuery({
    queryKey: ["shared-official-link-notices"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_shared_official_link_notices", { p_days: 14 });
      // A missing RPC is an empty source, not a failure: no retry, no error state.
      if (isMissingFunction(error)) return [];
      if (error) throw error;
      return (data ?? []) as SharedOfficialLinkNotice[];
    },
    enabled,
    staleTime: 5 * 60_000,
  });
}
